/**
 * MIONA Loader – Pulsierender Ring
 * Zeigt den Loader bei Seitenwechseln (Navigation).
 * Nicht beim initialen Laden (kein Flash).
 */
(function() {
  const loader = document.getElementById("miona-loader");
  if (!loader) return;

  let navigating = false;
  let showTimer = null;
  const SHOW_DELAY = 200;

  function showLoader() {
    clearTimeout(showTimer);
    showTimer = setTimeout(function() {
      navigating = true;
      loader.classList.add("is-visible");
    }, SHOW_DELAY);
  }

  function hideLoader() {
    clearTimeout(showTimer);
    navigating = false;
    loader.classList.remove("is-visible");
  }

  document.addEventListener("click", function(e) {
    const link = e.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    if (link.target === "_blank" ||
        href.startsWith("#") ||
        href.startsWith("javascript:") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        link.hasAttribute("download")) return;

    /* Cart-Links ausschliessen (Drawer oeffnet per JS, keine Navigation) */
    if (href === "/cart" || href.includes("/cart") ||
        link.closest("[data-cart-trigger]") ||
        link.closest("cart-drawer") ||
        link.closest(".header__cart") ||
        link.hasAttribute("aria-controls")) return;

    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return;
    } catch(err) { return; }

    showLoader();
  });

  document.addEventListener("submit", function(e) {
    const form = e.target;
    if (form.action && (form.action.includes("/cart") || form.action.includes("cart/add"))) return;
    if (form.closest("[data-product-form]") || form.closest("product-form")) return;
    if (form.hasAttribute("data-ajax") || form.hasAttribute("is")) return;
    showLoader();
  });

  window.addEventListener("pageshow", function(e) {
    if (e.persisted) {
      hideLoader();
    }
  });

  let safetyTimer;
  const observer = new MutationObserver(function() {
    if (loader.classList.contains("is-visible")) {
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(function() {
        hideLoader();
      }, 4000);
    }
  });
  observer.observe(loader, { attributes: true, attributeFilter: ["class"] });
})();